export const IMG_PATH = '/img/v2';

export const ROUTES_PATHS = {
  HOME: '/',
  ACCEPTABLE_USE: '/acceptable-use',
  AMAZON_SHOP: '/amazon-shop',
  CONTACT: '/contact-us',
  FAQ: '/support',
  OFFER_TO_UTILITIES: '/our-offer-to-utilities',
  PRIVACY_POLICY: '/privacy-policy',
  REQUEST_A_DEMO: '/request-a-demo',
  TERMS_AND_CONDITIONS: '/terms-and-conditions',
  VOLTABOT: '/reduce-switching',

  BLOG: '/blog',
  BLOG_POST: '/blog/:slug',

  CASE_STUDIES: '/case-studies/cut-energy-bill-uk-case-study',

  OUR_TECHNOLOGY: '/our-technology',
  APIS_AND_INTEGRATIONS: '/our-technology/apis-and-integrations',
  ENERGY_INTELLIGENCE: '/our-technology/energy-intelligence',
  CONTINUOUS_LEARNING: '/our-technology/continuous-learning',
  HARDWARE: '/our-technology/hardware',
  SMART_METER_INTEGRATION: '/our-technology/smart-meters-integration',
  VOLTAWARE_SENSORS: '/our-technology/voltaware-sensors',
  INTEGRATE_WITH_VOLTAWARE: '/integrate-with-voltaware',

  SUPPORT: '/support',
  SUPPORT_MATERIALS: '/support/materials',

  ABOUT: '/team/about-us',
  CAREERS: '/team/work-with-us',

  // External
  FOR_BUSINESS: 'https://volta-monitoring.com',

  // Social Media
  EMAIL: 'enquiries@voltaware.com',
  FACEBOOK: 'https://www.facebook.com/voltaware/',
  LINKEDIN: 'https://www.linkedin.com/company/voltaware',
  X: 'https://twitter.com/voltaware',
  WHATSAPP: 'https://wa.me/+447518851713',
};
